export default __webpack_public_path__ + "static/media/pin.3216ed9a.svg";